export const deconstructRef = (ref: string) => ref.split('/').slice(1);
